import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { unsubscribe } from '@app/utils';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Passenger } from '@app/models/micro';
import { PassengerService } from '@app/services/micro/passenger.service';
import {GlobalsService} from "@services/micro/globals.service";
import {StatusBag} from "@app/enums";


@Component({
    selector: 'app-carryon-offer-modal',
    templateUrl: './carryon-offer-modal.component.html',
    styleUrls: ['./carryon-offer-modal.component.scss'],
    standalone: false
})
export class CarryonOfferModalComponent implements OnInit, OnDestroy {

  @Input() typeModal: 'offer' | 'bag' = 'bag';
  tittle: string;
  offer: any = [];
  countIncludes =  0;
  constructor(
    private modalService: NgbModal,
    private _passengers: PassengerService,
    private _globals: GlobalsService,
  ) {}

  ngOnInit() {
    const reservation = this._globals.getReservation();
    const { flightSummary } = reservation;
    const [firstPassenger] = this._passengers.getPassengerSelection();
    const {legCode} = flightSummary
    this.countIncludes = firstPassenger.bagStack.filter(x => x.status == StatusBag.INCLUDE).length;
    this.offer = firstPassenger.bagOfferStack.filter(item => item.order <= 5 && item.order !== 4).map(item => {
      const currencyFind = item?.currencyPerLeg.find( currencyItem => currencyItem.legCode === legCode)
      const {currencyCode, total} = currencyFind.currency
      return {
        total,
        currencyCode,
        bagNumber: `carryonOfferModal.${this.trasformName(item.order)}`,
      }
    });
    console.log('[offer]', this.offer)
    this.initPage();
  }

  ngOnDestroy(): void {
  }

  initPage() {
    this.tittle = this.typeModal == 'offer' ? 'carryonOfferModal.titleOffer' : 'carryonOfferModal.titleBag'
  }
  /**
    Cierra todos los modales abiertos.
    Este método se ejecuta cuando el usuario decide cerrar el modal.
    @return void - No retorna ningún valor.
  **/
  onClose() {
    this.modalService.dismissAll();
  }
  trasformName(order: number) {
    let name = '';
    switch (order) {
      case 1: name = 'firstBag';
      break;
      case 2: name = 'secondBag';
        break;
      case 3: name = 'thirdBag';
        break;
      case 5: name = 'fiveBag';
        break;

    }
    return name
  }
}
